import { NeuTable } from "@neutron/react";
import React from "react";

/**
 * A thin wrapper around the `<NeuTable>` component. Use `<DataTable>` to replace most of the tables that we're using
 * @NeutronUpdate Will need to add `kind`, `sticky`, and `size` to this
 */

export function Table(props: { sticky?: '', kind?: 'default' | 'striped', children?: React.ReactNode, className?: string , onSort?: (event: any) => void}) {
    return (
        <NeuTable sticky={props.sticky ? props.sticky : 'header'} kind="striped" size="default" className={props.className}>
            {props.children}
        </NeuTable>
    )
}

/**
 * A thin wrapper around `<NeuTableHeading>`
 * @NeutronUpdate This will need to get replaced with `<NeuTable unit="header">`
 */

export function TableHeader(props: { children?: React.ReactNode, className?: string, icon?: 'desc' | 'none' | 'asc' | undefined, slot?: string}) {
    return (
        <NeuTable id="" unit="header" className={props.className}>
            {props.children}
        </NeuTable>
    )
}

/**
 * A thin wrapper around the `<NeuTableRow>`
 * @NeutronUpdate Will require changing from `<NeuTableRow>` to `<NeuTable unit="row">`
 */

export function TableRow(props: { children?: React.ReactNode, columns?: string | [], rowspan?: number | undefined, className?: string, header?: boolean }) {
    return (
        <NeuTable rowspan={props.rowspan} unit="row" className={props.className}>
            {props.children}
        </NeuTable>
    )
}

/**
 * A thin wrapper around the `<NeuTableBody>`
 * @NeutronUpdate Will require changing from `<NeuTableBody>` to `<NeuTable unit="body">`
 */
export function TableBody(props: { children?: React.ReactNode, className?: string, style?: { [key: string]: any; }}) {
    return (
        <NeuTable unit="content" className={props.className} style={props.style}>
            {props.children}
        </NeuTable>
    )
}

export function TableColumn(props: { direction?: 'asc' | 'desc' | 'none', sort?: boolean, children?: React.ReactNode, className?: string, onClickTableColumn?: any, style?: React.CSSProperties, id?: string}) {
    return (<>
        {props.onClickTableColumn ?
            <NeuTable onClick={() => {props.onClickTableColumn!({'column': props.id!, 'direction': props.direction === 'desc' ? 'asc' : 'desc'!})}} id={props.id} unit="column" direction={props.direction} sort={props.sort} className={props.className} style={props.style}>
                {props.children}
            </NeuTable> :
            <NeuTable id={props.id} unit="column" direction={props.direction} sort={props.sort} className={props.className} style={props.style}>
                {props.children}
            </NeuTable>}
        </>
    )
}